import { jsx as _jsx } from "react/jsx-runtime";
import { isEqual } from "lodash";
import React, { memo, useRef } from "react";
import { isCastAvailable } from "@common/services/helpers";
import { KEY_ENTER, KEY_SPACE } from "@config/constants";
var ChromeCastButton = function() {
    var refChromecastButton = useRef();
    var handleKeyDownHandler = function(e) {
        var key = e.which;
        if (key === KEY_SPACE || key === KEY_ENTER) {
            e.stopPropagation();
            refChromecastButton.click();
        }
    };
    return isCastAvailable() && /*#__PURE__*/ _jsx("google-cast-launcher", {
        ref: refChromecastButton,
        class: "google-cast-button",
        tabIndex: "0",
        onClick: function(event) {
            return event.stopPropagation();
        },
        onKeyDown: handleKeyDownHandler
    });
};
var areEqual = function(prevProps, nextProps) {
    return isEqual(prevProps, nextProps);
};
export default /*#__PURE__*/ memo(ChromeCastButton, areEqual);
